import styled from 'styled-components'
import { generateMedia } from 'styled-media-query'
import { Link } from 'gatsby'
import { customMedia } from '../../../utils/breakpoints'

export const FooterLinksList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;  

  ${customMedia.lessThan('sm')`
    &:nth-of-type(1) {
      grid-column: 1/2;
      grid-row: 2;
    }

    &:nth-of-type(2) {
      grid-column: 1/2;
      grid-row: 3;
    }

    &:nth-of-type(3) {
      grid-column: 2/3;
      grid-row: 2/4;
    }
  `}
`
export const FooterTitleLinks = styled.li`
  font-family: ${props => props.theme.font};
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 34px;
  font-weight: bold;
  color: ${props => props.theme.footer.desktop.menu.title};

  ${customMedia.lessThan('md')`
    font-size: 14px;
  `}

  ${customMedia.lessThan('sm')`
    font-size: 16px;
    display: inline;
    margin-bottom: 0;
    padding: 0 0 0 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 0 0 0 24px;
  `}
`

export const FooterLinksItems = styled.li`
  margin-bottom: 25px;

  ${customMedia.lessThan('sm')`
    margin-left: 40px;
    padding: 0 0 0 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 0 0 0 24px;
  `}

  ${customMedia.between('sm', 'lg')`
    margin-bottom: 2rem;
  `}
`

export const FooterExternalLink = styled.a`
  font-family: ${props => props.theme.font};
  font-size: 14px;
  font-weight: normal;
  line-height: 115%;
  color: ${props => props.theme.footer.desktop.menu.text};
  text-decoration: none;

  &:hover {
    color: #000E40;
  }
`

export const FooterInternalLink = styled(Link)`
  font-family: ${props => props.theme.font};
  font-size: 14px;
  font-weight: normal;
  color: ${props => props.theme.footer.desktop.menu.text};
  text-decoration: none;
  line-height: 1.3;

  &:hover {
    color: #000E40;
  }
`

export const LastMenu = styled.div`

`

export const FooterTel = styled.div`
  svg {
    fill: white;
  }
  ${customMedia.lessThan('sm')`
    padding-left: 35px;
  `}
`
export const Tel = styled.a`
  font-family: ${props => props.theme.font};
  font-size: 14px;
  line-height: 170%;
  color: #161616;
  margin-bottom: 10px;  
`
  

export const FooterLibras = styled.div`
  font-family: Roboto, sans-serif, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  cursor: pointer;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.04em;
  padding-left: 18px;
  padding-right: 18px;
  justify-content: space-between;
  color: white;
  width: 180px;
  height: 43px;
  margin-bottom: 10px;
  background: #000F40;
  border-radius: 4px;

  ${customMedia.between('sm', 'lg')`    
    width: 147.43px;
  `}
`
